import $ from 'jquery';
import * as Sentry from '@sentry/browser';
require('jquery-migrate');
require('@benmajor/jquery-touch-events');
jQuery.migrateMute = true;
window.Sentry = Sentry;
window.jQuery = $;
window.$ = $;
require('tether');
require('lodash');
require('bootstrap');
require('owl.carousel');
